import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import Home from '../pages/Home';
import Apresentacao from '../pages/Apresentacao';
import Local from '../pages/Local';
import Programacao from '../pages/Programacao';
import Palestrantes from '../pages/Palestrantes';
import Certidoes from '../pages/Certidoes';
import Inscricao from '../pages/Inscricao';
import InscricaoOAB from '../pages/InscricaoOAB';
import Valores from '../pages/Valores';
import Certificado from '../pages/Certificado';
import Material from '../pages/Material';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/apresentacao" component={Apresentacao} />
      <Route exact path="/local" component={Local} />
      <Route exact path="/certidoes" component={Certidoes} />
      <Route exact path="/programacao" component={Programacao} />
      <Route exact path="/valores" component={Valores} />
      <Route exact path="/palestrantes" component={Palestrantes} />
    {/* <Route exact path="/inscricao" component={Inscricao} />
    <Route exact path="/inscricao/oab" component={InscricaoOAB} /> */}
      <Route exact path="/certificado" component={Certificado} />
      <Route exact path="/material" component={Material} />
    </Switch>
  );
}
